module.exports = __webpack_public_path__ + "static/media/LBLogomark.d4a03387.svg";